import { type ReactNode } from 'react';
import { Icon } from '@ics-portal/guardian';
import styles from './CveCvssSection.module.scss';

export interface CveCvssGraphPlaceholderProps {
    message?: string;
}

export function CveCvssGraphPlaceholder({
    message = 'Radar chart coming soon',
}: CveCvssGraphPlaceholderProps): ReactNode {
    return (
        <div
            className={`flex flex-column align-items-center justify-content-center gap-2 flex-none border-round-lg ${styles.graphPlaceholder}`}
        >
            <Icon name="radar" fontSize="large" />
            <span className="text-sm text-secondary">{message}</span>
        </div>
    );
}
